import { render, staticRenderFns } from "./FacebookCallback.vue?vue&type=template&id=23481068"
import script from "./FacebookCallback.vue?vue&type=script&lang=js"
export * from "./FacebookCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports